import React from "react";
import { Link } from "react-router-dom";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { resolveLogoUrl } from "@/lib/branding";

/**
 * Shared brand mark used by the footer (and any other non-header surface
 * that wants a linked logo). Pulls the official AllSale™ mark from
 * `settings.logo_url` (single source of truth), falling back to the baked-
 * in Cloudinary URL when site-settings is temporarily unreachable so the
 * site never renders un-branded.
 */
export default function Logo({ className = "" }) {
  const { data: settings = {} } = useSiteSettings();
  const logoUrl = resolveLogoUrl(settings);
  return (
    <Link
      to="/"
      className={`inline-flex items-center gap-2 ${className}`}
      data-testid="footer-logo"
    >
      <img
        src={logoUrl}
        alt="AllSale"
        data-testid="brand-logo-img"
        className="h-9 w-auto"
        draggable={false}
      />
    </Link>
  );
}
